"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSymbolConfigManager = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const trade_utils_lib_1 = require("trade_utils_lib");
const Fetch = (symbol) => {
    if (!symbol) {
        return (0, rxjs_1.throwError)(() => "FetchSymbolTradeInfo: symbol cannot be null");
    }
    return (0, trade_utils_lib_1.requestWithRetry)(() => {
        return (0, FutureAPI_1.queryUserSymbolConfigure)(symbol);
    }, { name: "queryUserSymbolConfigure", maxRetryCount: 2 });
};
function Factory(symbol) {
    const triggerSubject = new rxjs_1.Subject();
    const observable = (0, rxjs_1.merge)(triggerSubject, // 主动触发事件
    (0, trade_utils_lib_1.getTradeDependencyInstance)()
        .appState.asObservable()
        .pipe((0, operators_1.filter)((sta) => sta === trade_utils_lib_1.AppState.enterToForeground), (0, operators_1.skip)(1)));
    let cache = null;
    const publisher = observable.pipe((0, operators_1.startWith)({ symbol }), (0, operators_1.switchMap)((res) => {
        if (typeof res === "object") {
            cache = Object.assign(cache !== null && cache !== void 0 ? cache : {}, res);
        }
        if (!(cache === null || cache === void 0 ? void 0 : cache.symbol)) {
            return rxjs_1.NEVER;
        }
        return Fetch(cache === null || cache === void 0 ? void 0 : cache.symbol).pipe((0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)({
                error,
            });
        }));
    }), (0, operators_1.share)({ connector: () => new rxjs_1.BehaviorSubject({}), resetOnError: false, resetOnComplete: false, resetOnRefCountZero: false }));
    const refresh = (value) => {
        triggerSubject.next(value);
    };
    return {
        publisher,
        refresh,
    };
}
function PublishManager() {
    const publisherMap = new Map();
    function getInstance(symbol) {
        if (!publisherMap.has(symbol)) {
            const factory = Factory(symbol);
            publisherMap.set(symbol, factory);
        }
        return publisherMap.get(symbol);
    }
    function getPublish(symbol) {
        return getInstance(symbol).publisher;
    }
    function refresh(symbol) {
        getInstance(symbol).refresh({ symbol });
    }
    return {
        getPublish,
        refresh,
    };
}
exports.UserSymbolConfigManager = PublishManager();
